import { AppLayout } from './AppLayout';
import { Container } from '@/components/Container';
import { useMapFeatures } from '@/maps/useMapFeatures';
import { cn } from '@/trailmix/lib/cn';
import { useWindowDimensions } from '@/window/useWindowDimensions';
import { MapboxMapV2 } from '@/maps/MapboxMapV2';
import { usePage } from '@inertiajs/react';
import { MapPlace } from '@/pages/types';
import { placesToFeatureCollection } from '@/maps/placesToFeatureCollection';
import { PageProps } from '@/types';

type MapPageProps = PageProps<{
    mapPlaces?: { data: MapPlace[] };
    visitedMapPlaceIds?: number[];
    showMap?: boolean;
}>;

type MapLayoutProps = {
    children: React.ReactNode;
};

export function MapLayout({ children }: MapLayoutProps) {
    const { mapPlaces, visitedMapPlaceIds, showMap = true, features } = usePage<MapPageProps>().props;
    const mapFeatures = placesToFeatureCollection(mapPlaces?.data ?? [], visitedMapPlaceIds ?? []);
    const { centerLocation, radius } = useMapFeatures();
    const { isDesktop } = useWindowDimensions();

    return (
        <AppLayout withContainer={false}>
            {showMap && (
                <div className={cn('h-[40vh] w-full border-b-4 border-gray-300')}>
                    <MapboxMapV2
                        collection={mapFeatures}
                        cooperativeGestures={isDesktop}
                        centerLocation={centerLocation}
                        radiusInMiles={radius}
                        showPhotoMarkers={features.mapPhotoMarkers}
                    />
                </div>
            )}
            <Container className='pt-4'>{children}</Container>
        </AppLayout>
    );
}
